function redrawArea(elements) {
    elements.forEach(function(element) {
        let items = element.querySelectorAll('.js-unify-height-item');
        redraw(items);
    });
}

function redraw(elements) {
    let height = -1;

    elements.forEach(function (element) {
        element.style.height = '';
    });

    elements.forEach(function (element) {
        if(height < element.offsetHeight) {
            height = element.offsetHeight;
        }
    });

    elements.forEach(function (element) {
        element.style.height = height+'px';
    });
}

/**
 * Zavolá redraw i po načtení webfontů a po plném načtení stránky.
 * Při DOMContentLoaded může být text ještě vysázený fallback fontem (např. lokálně
 * nainstalovaným Roboto Condensed) — po doswapu webfontu se text přeláme jinak,
 * ale výška už je zafixovaná inline. Font swap nevyvolá resize.
 */
function redrawOnLateLayout(redrawAll) {
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(redrawAll);
    }

    window.addEventListener('load', redrawAll);
}

export function applyTo(selector) {
    let elements = document.querySelectorAll(selector);

    redrawArea(elements);

    window.addEventListener('resize', function() {
        redrawArea(elements);
    });

    redrawOnLateLayout(function () {
        redrawArea(elements);
    });
}

export function applyDataAttribute() {
    console.log('apply unify');
    let elements = document.querySelectorAll('[data-unify-height]');
    let groups = [];
    let elementsGroups = [];

    elements.forEach(function(item) {
        let groupName = item.getAttribute('data-unify-height');
        let groupKey = groups.indexOf(groupName);

        if(groupKey < 0) {
            groupKey = groups.push(groupName) - 1;
        }

        if(elementsGroups[groupKey] === undefined) {
            elementsGroups[groupKey] = [];
        }

        elementsGroups[groupKey].push(item);
    });

    elementsGroups.forEach(function(elements) {
        redraw(elements);
    });

    redrawOnLateLayout(function () {
        elementsGroups.forEach(function(elements) {
            redraw(elements);
        });
    });

    window.addEventListener('resize', function() {
        elementsGroups.forEach(function(elements) {
            redraw(elements);
        });
    });

    window.addEventListener('shown.bs.collapse', function() {
        elementsGroups.forEach(function(elements) {
            redraw(elements);
        });
    });

    window.addEventListener('shown.bs.tab', function() {
        elementsGroups.forEach(function(elements) {
            redraw(elements);
        });
    });
}
